<div class="user-dropdown" [class.user-dropdown--inline]="inline">
  <app-button *ngIf="!inline" variant="outline" color="light" (click)="toggleDropdown()" [ariaLabel]="userName + ' menu'">
    <app-user-avatar class="user-dropdown__avatar" size="sm" [photo]="photo" [firstName]="firstName" [lastName]="lastName" [identifier]="userEmail"></app-user-avatar>
    <span class="user-name">{{ userName }}</span>
    <i class="fas fa-chevron-down" aria-hidden="true"></i>
  </app-button>
  <div class="user-dropdown__menu" [class.active]="isOpen || inline">
    <div class="user-dropdown__header" *ngIf="userName || userEmail">
      <app-user-avatar class="user-dropdown__header-avatar" size="md" [photo]="photo" [firstName]="firstName" [lastName]="lastName" [identifier]="userEmail"></app-user-avatar>
      <div class="user-dropdown__header-text">
        <div class="user-dropdown__name" *ngIf="userName">{{ userName }}</div>
        <div class="user-dropdown__email" *ngIf="userEmail">{{ userEmail }}</div>
      </div>
    </div>
    <div class="user-dropdown__divider" *ngIf="!inline && (userName || userEmail)"></div>
    <a *ngIf="profileLink && !inline" class="user-dropdown__item" [routerLink]="profileLink" (click)="closeDropdown()">
      <i class="fas fa-user"></i>
      <span>{{ 'nav.yourProfile' | transloco }}</span>
    </a>
    <a *ngIf="myJobsLink" class="user-dropdown__item" [routerLink]="myJobsLink" (click)="closeDropdown()">
      <i class="fas fa-briefcase"></i>
      <span>{{ 'nav.myJobs' | transloco }}</span>
    </a>
    <a *ngIf="settingsLink" class="user-dropdown__item" [routerLink]="settingsLink" (click)="closeDropdown()">
      <i class="fas fa-cog"></i>
      <span>{{ 'nav.settings' | transloco }}</span>
    </a>
    <div class="user-dropdown__divider" *ngIf="!inline && (profileLink || myJobsLink || settingsLink)"></div>
    <div class="user-dropdown__item" (click)="logout()">
      <i class="fas fa-sign-out-alt"></i>
      <span>{{ 'nav.logout' | transloco }}</span>
    </div>
  </div>
</div>
